import FlowChart from './flowChart';

export default FlowChart;
